<mat-card class="content-card">
    <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <div fxLayout="column">
          <div fxLayout="row wrap" fxLayoutGap="10px">
            <button mat-raised-button color="accent" [disabled]="table.selection.isEmpty()" (click)="exportCards()">Export</button>

              <!--<a *appHasRoles="['admin']" color="primary" mat-raised-button routerLink="/cards/card-renewal">
                <span>Renewal</span>
              </a>-->

            <span style="background-color: orange; padding: 5px; margin-left: 5px; margin-right: 5px; border-radius: 5px;" *ngIf="refreshPollCounter > 0">
              Refreshing list... ({{refreshPollCounter}})
            </span>

          </div>
        </div>
        <div fxLayout="column">
          <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
              <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel" [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
              <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel" [(ngModel)]="table.filters.endFilterDate"></app-date-edit>
              <mat-form-field class="date-filter-field">
                <mat-select placeholder="Date filters" [(ngModel)]="table.filters.dateFilterCols" multiple>
                  <mat-option *ngFor="let dateFilter of dateFiltersList" [value]="dateFilter.name">
                    {{dateFilter.header}}
                  </mat-option>
                </mat-select>
              </mat-form-field>


            <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select placeholder="Card status" [(ngModel)]="table.filters.cardStatusFilter" multiple>
                <mat-option [value]="cardStatus.InProduction">In Production</mat-option>
                <mat-option [value]="cardStatus.Shipped">Shipped</mat-option>
                <mat-option [value]="cardStatus.PendingActivation">Pending activation</mat-option>
                <mat-option [value]="cardStatus.Activated">Activated</mat-option>
                <mat-option [value]="cardStatus.ExpiredCard">Expired card</mat-option>

                <mat-option style="color: red;" [value]="cardStatus.CardClosed">Closed</mat-option>

              </mat-select>
            </mat-form-field>

              <mat-form-field>
                <mat-label>Brand</mat-label>
                <mat-select placeholder="Brand filters" [(ngModel)]="table.filters.companiesFilter" (ngModelChange)="onCompanyChange($event)" multiple>
                  <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Product</mat-label>
                <mat-select placeholder="Brand filters" [(ngModel)]="table.filters.productsFilter" multiple>
                  <mat-option [style]="product.active ? '' : 'color: grey;'" *ngFor="let product of productsToShow" [value]="product.id">{{product.internalName}}<span *ngIf="!product.active" style="color: red;"> (I)</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="search-field">
                <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                  [(ngModel)]="table.filters.str">
              </mat-form-field>
              <button #searchButton mat-icon-button (click)="onSearch()" [disabled]="startDateFilter.invalid || endDateFilter.invalid">
                <mat-icon>search</mat-icon>
              </button>
              <button mat-icon-button (click)="table.clearFilter()">
                  <mat-icon>clear</mat-icon>
              </button>
          </div>
        </div>
      </div>
  <app-mat-table-generator #table
    tableName="cardsTable"
    [saveFilters]="true"
    [useEmbededFilter]="false"
    [columns]="columns"
    [dataSource]="dataSource"
    [editEnabled]="false"
    [deleteEnabled]="false"
    [multiselectEnabled]="true"
    [viewLink]="getViewLink"
    [customActions]="cardsCustomActions"
    [editLink]="getEditLink" >
  </app-mat-table-generator>
</mat-card>
